import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function Checkdata(code) {
    if (code) {
        let rs = []
        let Url = genURL("CSSITE/Getsite?Code=" + code + "&user=" + localStorage.getItem("Username"))
        console.log(Url);
        await axios.get(Url, { timeout: 5000 }).then((res) => {
            if (res.data.length === 1) {
                rs.push(res.data[0].MYNAMETH)
                rs.push(res.data[0].CODE)
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};